import { cx } from "class-variance-authority";
import { Box } from "../Box/Box";
import { Caret } from "../Caret/Caret";
import { Clamp } from "../Clamp/Clamp";
import { Collapse } from "../Collapse/Collapse";
import { useState, type PropsWithChildren } from "react";

import * as styles from "./Accordion.module.scss";

type AccordionProps = PropsWithChildren<{
  label: string;
  initialOpen?: boolean;
}>;

const Accordion = ({
  label,
  initialOpen = false,
  children,
}: AccordionProps) => {
  const [isOpen, setIsOpen] = useState(initialOpen);

  return (
    <Box
      className={styles.accordionGroup}
      onClick={() => setIsOpen((v) => !v)}
      noChildrenSpace
      title={
        <div className={cx(styles.header, { [styles.isOpen]: isOpen })}>
          {label}
        </div>
      }
      clamp={
        <Clamp variant="grey">
          <Caret variant={isOpen ? "up" : "down"} className={styles.caret} />
        </Clamp>
      }
    >
      <Collapse
        isOpen={isOpen}
        skipInitial={!initialOpen}
        className={styles.content}
      >
        {children}
      </Collapse>
    </Box>
  );
};

export { Accordion };
